module.exports = __webpack_public_path__ + "static/media/ivf.53f6b56b.jpg";